import { render, staticRenderFns } from "./OperaVerifyPayCodeWindow.vue?vue&type=template&id=be928228&scoped=true"
import script from "./OperaVerifyPayCodeWindow.vue?vue&type=script&lang=js"
export * from "./OperaVerifyPayCodeWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaVerifyPayCodeWindow.vue?vue&type=style&index=0&id=be928228&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be928228",
  null
  
)

export default component.exports